// next-i18next.config.js
module.exports = {
  i18n: {
    locales: ['ar', 'en'],
    defaultLocale: 'ar',
    localeDetection: false, 
  },
  returnNull: false,
  ns: 
  [
    'products',
    'categoryTabs',
    'productsHeroBanner',
    'filterModal',
    'filterSidebar',
    'desktopHeader',
    'footer',
    'common',
    'account',
    'alerts',
    'address',
    'cart',
    'contactus',
    'deliveryPolicy',
    'notfound',
    'payment',
    'personalizeModal',
    'product',
    'removePhone'
  ],
  defaultNS: 'common',
};